import { render, staticRenderFns } from "./BaseText.vue?vue&type=template&id=9bd50ede&scoped=true&"
import script from "./BaseText.vue?vue&type=script&lang=js&"
export * from "./BaseText.vue?vue&type=script&lang=js&"
import style0 from "./BaseText.vue?vue&type=style&index=0&id=9bd50ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd50ede",
  null
  
)

export default component.exports